@if (initialized) {

  @if (formGroup) {

    <div class="auth-container flex align-items-center justify-content-center p-3">

      <div class="surface-card border-round-2xl border-1 border-100 shadow-1 overflow-hidden w-full" style="max-width: 64rem;">

        <!-- Two Column Layout -->
        <div class="flex flex-column md:flex-row" style="min-height: 500px;">

          <!-- Left Column: Existing Users Login -->
          <div class="col-12 md:col-6 bg-blue-50 p-4 md:p-6 flex flex-column justify-content-center">
            <div class="md:mb-8 md:text-left text-center">
              <div class="flex align-items-center gap-2 mb-5 md:justify-content-start justify-content-center">
                <img src="../../../../assets/images/logo_klaus_light_blue.svg" class="w-8rem" alt="logo">
              </div>
              <h2 class="md:text-2xl text-xl font-bold text-900 md:mb-3 mb-0">Sie sind bereits Kunde?</h2>
              <p class="text-600 mb-5 line-height-3 md:text-base text-sm">
                Melden Sie sich einfach mit Ihren bestehenden Zugangsdaten an.
              </p>
              <div class="flex flex-column">
                <p-button
                  styleClass="w-full"
                  (onClick)="navigateToLogin()">
                  <div class="flex gap-2 justify-content-center w-full">
                    <span class="font-semibold">JETZT ANMELDEN</span>
                    <i class="pi pi-sign-in"></i>
                  </div>
                </p-button>
              </div>
            </div>
          </div>

          <!-- Right Column: Registration Form -->
          <div class="col-12 md:col-6 p-4 md:p-6 flex flex-column justify-content-center">
            <div class="mb-5 md:text-left text-center">
              <h1 class="md:text-2xl text-xl font-bold text-900 mb-2">Neukunden-Registrierung</h1>
              <p class="text-500 text-sm mb-0">Erstellen Sie in wenigen Schritten Ihr neues Versicherungskonto.</p>
            </div>

            <div class="flex flex-column gap-4" [formGroup]="formGroup">

              <!-- Phone Number Input -->
              <div class="flex flex-column gap-2">
                <label class="text-sm font-semibold text-700 ml-1">Handynummer</label>
                <span class="p-input-icon-left block">
                  <i class="flex gap-2 text-primary line-height-1 font-medium" style="font-style: normal;">
                    <div class="flag-container">
                      <div class="stripe black"></div>
                      <div class="stripe red"></div>
                      <div class="stripe gold"></div>
                    </div>+49</i>
                  <p-inputNumber
                    class="block"
                    styleClass="block"
                    [inputStyle]="{'padding-left': '6rem', width: '100%'}"
                    [format]="false"
                    placeholder="0170 1234567"
                    formControlName="phoneNumber" />
                </span>
              </div>

              <!-- Error Message -->
              <span *ngIf="errorMessage" class="text-red-600">
                <p-message [ngStyle]="{'word-break': 'break-word'}" [text]="errorMessage" severity="error"
                           styleClass="block text-left"></p-message>
              </span>

              <!-- Register Button -->
              <app-button [busy]="busy"
                          [disabled]="!formGroup.valid"
                          [label]="'Konto erstellen'"
                          [class]="'w-full'"
                          [showIcon]="false"
                          (onClick)="handleRequestOtpCode()">
              </app-button>

              <!-- Terms and Conditions -->
              <div class="text-center pt-2">
                <p class="text-xs text-500 line-height-3 px-3 mb-0">
                  Durch die Registrierung bestätigst du unsere
                  <a href="https://www.klaus-versichert.de/datenschutz/" target="_blank" class="text-primary hover:underline cursor-pointer">
                    Datenschutzbestimmungen
                  </a>
                  und
                  <a href="https://www.klaus-versichert.de/agb/" target="_blank" class="text-primary hover:underline cursor-pointer">Allgemeine Geschäftsbedingungen</a>.
                </p>
              </div>

            </div>
          </div>

        </div>

      </div>

    </div>

  }

}
